<template>
  <v-dialog
    v-model="showPopup"
    persistent
    max-width="520"
    @keydown.passive.esc='$emit("cancel")'
  >
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Add New Warehouse
      </v-card-title>
      <v-card-text>
        <v-form
          v-model='valid'
          @keydown.native.enter.prevent='validate'
        >
          <div>
            <span class="label-text">Title *</span>
            <div class="input-mb input-box">
              <v-text-field
                dense
                placeholder="Enter warehouse title"
                v-model="name"
                :rules="nameRules"
                maxlength="128"
                class="r-field item-name-field"
              />
            </div>
          </div>
          <div>
            <span class="label-text">Notes</span>
            <div class="input-mb input-box d-flex flex-nowrap">
              <v-textarea
                dense
                placeholder="Enter description"
                v-model="note"
                maxlength="128"
                class="r-field item-name-field"
              />
            </div>
          </div>
          <div>
            <span class="label-text">Currencies *</span>
            <div class="input-mb input-box">
              <v-select
                dense
                v-model="currencyId"
                :items="currencies"
                item-text="title"
                item-value="value"
                required
                class="general-settings-select"
              />
            </div>
          </div>
          <div>
            <v-checkbox
              v-model='setActive'
              label="set this warehouse active"
              color="#8074c2"
              class='mt-1'
            />
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('cancel')"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="validate"
          depressed
          class="save-btn small-size"
          :disabled='!valid'
        >
          Confirm
        </v-btn>
    </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import service from '@/services/warehouses'
import { mapGetters } from 'vuex'

const USD_CURRENCY_ID = 254

export default {
  props: {
    showPopup: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      name: '',
      note: '',
      currencyId: USD_CURRENCY_ID,
      setActive: false,
      nameRules: [
        v => !!v.length || 'Warehouse name is required'
      ],
      valid: true
    }
  },
  computed: {
    ...mapGetters('currency', ['getCurrencyList']),
    currencies() {
      return this.getCurrencyList.map((itm) => {
        return {
          value: itm.id,
          title: `${itm.code} - ${itm.currency} (${this.capitilizeWords(itm.location)})`
        }
      })
    }
  },
  methods: {
    capitilizeWords(phrase) {
      return phrase.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    },
    async validate() {
      const result = await service.addWarehouse({
        name: this.name,
        description: this.note,
        currencyId: this.currencyId,
        active: this.setActive
      })
      if (result?.data?.error?.type === 200) {
        this.$store.dispatch('warehouses/loadWarehousesList')
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
